import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { useControl } from "react-map-gl";
import CheapRuler from "cheap-ruler";
import * as turf from "@turf/turf";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "mapbox-gl/dist/mapbox-gl.css";

const DrawControl = (props) => {
  useControl(
    ({map}) => {
      const drawControl = new MapboxDraw(props);
      var newProps = {...props};
      // on draw.render update the measurements
      newProps.onRender = function (e) {
        var labelFeatures = [];
        var all = drawControl.getAll();
        var ruler = new CheapRuler(map.getCenter().lat, 'meters');
        if (all && all.features) {
          all.features.forEach(function (feature) {
            switch (turf.getType(feature)) {
              case 'Point':
                // label Points
                if (feature.geometry.coordinates.length > 0) {
                  var label = feature.geometry.coordinates[1].toFixed(4) + ', ' + feature.geometry.coordinates[0].toFixed(4);
                  labelFeatures.push(turf.point(feature.geometry.coordinates, {type: 'point', label: label}));
                }
                break;
              case 'LineString':
                // label Lines
                if (feature.geometry.coordinates.length > 0) {
                  var length = ruler.lineDistance(feature.geometry.coordinates);
                  var midpoint = ruler.along(feature.geometry.coordinates, length / 2);
                  var label = Math.round(length) + ' m';
                  labelFeatures.push(turf.point(midpoint, {type: 'line', label: label}));
                }
                break;
              case 'Polygon':
                // label Polygons
                if (feature.geometry.coordinates.length > 0 && feature.geometry.coordinates[0].length > 3) {
                  var area = turf.area(feature);
                  var label = Math.round(area * 0.000247105 * 100) / 100 + ' acre';
                  labelFeatures.push(turf.centroid(feature, {properties: {type: 'area', label: label}}));
                }
                break;
            }
          });
        }

        if (map.getSource('measurements-source')) {
          map.getSource('measurements-source').setData({
            type: 'FeatureCollection',
            features: labelFeatures
          });
        }
      };
      props = newProps;
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
      map.on('draw.render', props.onRender);
      return drawControl;
    },
    ({map}) => {
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
      map.off('draw.render', props.onRender);
    }, {
      position: props.position
    }
  );

  return null;
};

DrawControl.defaultProps = {
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {}
};

export default DrawControl;
